import { Box, BoxProps } from '@cp/ds/src/components/box';
import { Typography } from '@cp/ds/src/components/typography';
import React from 'react';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds';
import { useIsMobile, useTheme } from '@cp/ds/src/hooks';
import { styled } from '@cp/ds/src/theme';
import { formatPromocodeFreePeriod } from '@cp/entities/promocode';
import { GiftImage } from './gitftImage';

const Root = styled(Box, { name: 'PromocodeBanner' })(({ theme, onClick }) => ({
  backgroundColor: theme.palette.peach,
  padding: theme.spacing(2),
  borderRadius: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2.5),
  width: '100%',
  cursor: onClick ? 'pointer' : 'auto',
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    width: '415px',
  },
}));

export interface PromoBannerProps extends BoxProps {
  freePeriod?: string;
}
export const PromocodeBanner: React.FC<PromoBannerProps> = ({ freePeriod = 'P1M', ...props }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();

  return (
    <Root {...props}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography sx={{ textWrapStyle: 'pretty' }} variant="h3">
          {formatPromocodeFreePeriod({ freePeriod })} бесплатно{' '}
          <Typography variant={isMobile ? 'caption bold' : 'h3'}>по промокоду</Typography>
        </Typography>
        <Typography sx={{ color: theme.palette.gray }} variant="caption bold">
          Все возможности без ограничений
        </Typography>
      </Box>
      <GiftImage size={48} />
    </Root>
  );
};
